(ns ui.components.radio.view
  "The ZapKit Radio: one radio button with its label, an optional helper text and a mark
   for a required choice. It draws the DOM of `Radio.tsx` of zapkit-components, with the
   generated styles of `ui.components.radio.zapkit-styles`. ZapKit has no radio group: the
   caller puts the radios of a group in one element, and gives them the same `:name`."
  (:require
   [ui.components.radio.zapkit-styles :as styles]
   [ui.components.zapkit-variants :as variants]
   [ui.dom-globals :as dg]
   [ui.util :as uu]))

(defn circle-state
  "The visual state of the circle: `:checked`, `:unchecked`, `:disabled-checked` or
   `:disabled-unchecked`."
  [{:keys [checked? disabled?]}]
  (cond
    (and disabled? checked?) :disabled-checked
    disabled? :disabled-unchecked
    checked? :checked
    :else :unchecked))

(defn- slot-class
  [slot variants-map]
  (variants/slot-class (get styles/radio slot) variants-map))

(defn view
  "The ZapKit Radio. `:name` groups the radios. `:checked?` is the state, and `:on-change`
   is called with true when the user picks the radio. `:label` is the text, `:helper-text` is
   the small text under it, and `:required?` adds the mark. `:id` is the id of the input, and
   a radio that has none gets one. `:class` is added to the circle. The value of the radio is
   `:value`, a string or a number."
  [_props]
  (let [generated-id (str "radio-" (random-uuid))]
    (fn [{:keys [id value checked? disabled? required? label helper-text on-change class]
          input-name :name
          :as props}]
      (let [input-id (or id generated-id)
            helper-id (str input-id "-helper")
            disabled? (boolean disabled?)]
        [:div {:class (slot-class :root {})}
         [:label
          {:for   input-id
           :class (slot-class :control {:disabled disabled?})}
          [:input
           {:type             "radio"
            :id               input-id
            :name             input-name
            :value            value
            :checked          (boolean checked?)
            :disabled         disabled?
            :required         (boolean required?)
            :class            (slot-class :input {})
            :aria-describedby (when helper-text
                                helper-id)
            :on-change        (fn [e]
                                (when (and (not disabled?)
                                           (fn? on-change))
                                  (on-change (dg/target-checked e))))}]
          [:span
           {:class       (uu/cm (variants/slot-class (get styles/radio :circle)
                                                     {:state (circle-state props)})
                                ;; The circle keeps its size next to a long label.
                                ;; A flex row shrinks a fixed-size item without it.
                                "tw2-shrink-0"
                                class)
            :aria-hidden true}
           [:span {:class (slot-class :dot {:checked (boolean checked?)})}]]
          (when label
            [:span {:class (slot-class :label {:disabled disabled?})}
             label
             (when required?
               [:span {:class (slot-class :required {})} "*"])])]
         (when helper-text
           [:p
            {:id    helper-id
             :class (slot-class :helper {:disabled disabled?})}
            helper-text])]))))
